import styled from '@rsos/theme/styled';

export const StyledHint = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 14px;
`;

export const StyledLocationInfo = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 13px;
  margin-bottom: 8px;
`;

export const StyledDescription = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 13px;
  margin-bottom: 8px;
`;

export const StyledWarning = styled.div`
  color: #ff9800;
  font-size: 12px;
  margin-bottom: 12px;
  padding: 6px 8px;
  background: rgba(255, 152, 0, 0.1);
  border-radius: 4px;
`;

export const StyledInputWrapper = styled.div`
  margin-bottom: 8px;
`;

export const StyledSuccess = styled.div`
  color: #4caf50;
  font-size: 13px;
  margin-top: 8px;
`;

export const StyledError = styled.div`
  color: #f44336;
  font-size: 13px;
  margin-top: 8px;
`;

export const StyledCredentialsSection = styled.div`
  margin-top: 16px;
  padding-top: 16px;
`;
